<template>
    <div>
        <a-card>
            <span slot="title">{{ title }}</span>
            <div slot="extra" class="d-flex flex-row items-center">
                <a-button type="primary" icon="plus" @click="showModalCreate()">Tambah</a-button>
            </div>
        </a-card>

        <a-table :columns="columns" :data-source="data" bordered style="margin-top: 10px;"
        :pagination="pagination" 
        :scroll="widthScreen < 400 ? { x: 1200, y:500} : {}"
        :loading="loading.table" size="small"
        key="tblMonitoring" :rowKey="(record, index) => {return index;}"
        >
        <template slot="no" slot-scope="value, item, index">{{ index + 1 }}</template>
        <template slot="kode_layanan" slot-scope="value, item, index">{{ item.kode_layanan }}</template>
        <template slot="nama_layanan" slot-scope="value, item, index">{{ item.nama_pelayanan }}</template>
        <template slot="group_pelayanan" slot-scope="value, item, index">{{ item.group_pelayanan }}</template>
        <template slot="plafon" slot-scope="value, item, index">{{ formatRupiah(item.plafon_group) }}</template>
        <template slot="persentase" slot-scope="value, item, index">{{ item.persentase_klaim }} %</template>
        <template slot="keterangan" slot-scope="value, item, index">{{ item.note }}</template>
        <template slot="action" slot-scope="value, item, index">
          <div class="action-sect">
            <a-switch size="small" 
            style="width: 50px;"
            :checked="item.aktif_sts === '1'"
            @change="val => handleSwitchChange(val, item)"
            checked-children="On" un-checked-children="Off"/>

            <a-button type="primary" shape="circle" icon="form" @click="showModalCreateEdit(item)"/>
          </div>
        </template>
      </a-table>

      <a-modal
        :dialog-style="{ top: '20px' }"
        :width="800"
        :title="modalTitle"
        :visible="visibleModalCreate"
        @cancel="closeModalCreate"
      >
      <a-form class="m-form" :form="form">
        <a-row :gutter="8">

          <a-col span="12">
            <a-form-item label="Kode Layanan" :required="true">
              <a-input placeholder="Kode layanan" 
              :disabled="true"
                v-decorator="['kode_layanan', {
                  rules: [{
                    required: true,
                    message: 'Kode layanan is required!'
                  }]
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col span="12">
            <a-form-item label="Group Layanan" :required="true">
              <a-select
              @change="handleGroupChange"
              v-decorator="['group_layanan', {
                  rules: [{
                    required: true,
                    message: 'Group layanan is required!'
                  }]
                }]"
              >
                <a-select-option v-for="c in combo" :key="c.id_option" :value="c.option">{{ c.option }}</a-select-option>
              </a-select>
            </a-form-item>
          </a-col>

          <a-col span="12">
            <a-form-item label="Nama Layanan" :required="true">
              <a-input placeholder="Input nama layanan" 
                v-decorator="['nama_layanan', {
                  rules: [{
                    required: true,
                    message: 'Nama layanan is required!'
                  }]
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col span="12">
            <a-form-item label="Plafon Layanan" :required="true">
              <a-input placeholder="" 
                :disabled="plafonVisible"
                v-decorator="['plafon_layanan', {
                  rules: [{
                    required: true,
                    message: 'Plafon layanan is required!'
                  }]
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col span="12">
            <a-form-item label="Keterangan" :required="true">
              <a-textarea
                placeholder="Input keterangan"
                :auto-size="{ minRows: 5, maxRows: 5 }"
                v-decorator="['note', {
                  rules: [{
                    required: true,
                    message: 'Keterangan is required!'
                  }]
                }]"
              />
            </a-form-item>
          </a-col>

          <a-col span="12">
            <a-col span="24">
              <a-form-item label="Plan Layanan" :required="true">
                <a-select
                v-decorator="['plan_layanan', {
                    rules: [{
                      required: true,
                      message: 'Plan layanan is required!'
                    }]
                  }]"
                >
                <a-select-option v-for="p in plan" :key="p.name" :value="p.name">{{ p.name }}</a-select-option>
                </a-select>
              </a-form-item>
            </a-col>
            <a-col span="24">
              <a-form-item label="Persentase Layanan" :required="true">
                <!-- <a-input placeholder="Input persentase layanan" 
                  v-decorator="['persentase_klaim', {
                    rules: [{
                      required: true,
                      message: 'Persentase layanan is required!'
                    }]
                  }]"
                /> -->

                <a-input-number
                  :default-value="0"
                  :min="0"
                  :max="100"
                  style="width: 100%;"
                  :formatter="value => `${value}%`"
                  :parser="value => value.replace('%', '')"
                  v-decorator="['persentase_klaim', {
                    rules: [{
                      required: true,
                      message: 'Persentase layanan is required!'
                    }]
                  }]"
                />
              </a-form-item>
            </a-col>
          </a-col>

        </a-row>
      </a-form>

      <template slot="footer">
        <a-button key="back" @click="closeModalCreate">Cancel</a-button>
        <a-button
          v-if="state.modalMode == 'create'"
          key="submit"
          type="primary"
          :loading="loading.btn_submit"
          @click="handleSubmit"
          >Submit</a-button>

          <a-button
          v-if="state.modalMode == 'edit'"
          key="submit"
          type="primary"
          :loading="loading.btn_submit"
          @click="handleUpdateSubmit"
          >Save</a-button>
      </template>
      </a-modal>

    </div>
</template>

<script>
import Axios from 'axios';
import { mapGetters } from "vuex";
import CurrencyFormat from "@/mixins/CurrencyFormat";
import Global from "@/mixins/GlobalMethods";

const columns = [
  {
    title: 'No',
    width: 40,
    className: 'center',
    scopedSlots: { customRender: 'no' },
  },
  {
    title: 'Kode',
    dataIndex: 'kode_layanan',
    sorter: true,
    scopedSlots: { customRender: 'kode_layanan' },
  },
  {
    title: 'Nama Layanan',
    dataIndex: 'nama_pelayanan',
    sorter: true,
    scopedSlots: { customRender: 'nama_layanan' },
  },
  {
    title: 'Group Layanan',
    dataIndex: 'group_pelayanan',
    scopedSlots: { customRender: 'group_pelayanan' },
  },
  {
    title: 'Plan',
    dataIndex: 'plan',
    className: 'quotes-column',
    scopedSlots: { customRender: 'plan' },
  },
  {
    title: 'Plafon',
    dataIndex: 'plafon_group',
    className: 'center',
    scopedSlots: { customRender: 'plafon' },
  },
  {
    title: 'Persentase',
    dataIndex: 'persentase',
    className: 'center',
    scopedSlots: { customRender: 'persentase' },
  },
  {
    title: 'Keterangan',
    dataIndex: 'keterangan',
    scopedSlots: { customRender: 'keterangan' },
  },
  {
    title: 'Action',
    width: 120,
    className: 'center',
    scopedSlots: { customRender: 'action' },
  }
];

export default {
    mixins: [CurrencyFormat, Global],
    data(){
        return{
          title: 'Master Pelayanan',
          modalTitle: 'Create Pelayanan Kesehatan',
          data: [],
          loading: {
              table: false
          },
          columns,
          pagination: {},
          widthScreen: 0,
          heighScreen: 0,
          visibleModalCreate: false,
          state: {
            data: {},
            id: '',
            modalMode: 'create',
            editData: {}
          },
          combo: [],
          plan: [],
          kode: null,
          plafon: 0,
          plafonVisible: true,
          loading: {
            btn_submit: false,
            btn_edit: false
          }
        }
    },

    computed: {
        ...mapGetters(["getAuth", "getStandartFormatDate","getDefaultDateFormat"]),
    },

    beforeCreate() {
      this.form = this.$form.createForm(this);
    },

    mounted(){
        this.widthScreen = window.innerWidth
        this.heighScreen = window.innerHeight
        this.fetchList()
    },

    methods: {
        async fetchList(){
            this.loading.table = true
            try {
                const response = await Axios({
                  method: 'GET',
                  url: this.$serviceUrl + "pelayanan/list",
                  params: {
                      "X-API-KEY": this.getAuth.apikey
                  },
                  auth: {
                      username: this.getAuth.username,
                      password: this.getAuth.password
                  },
                })

                this.loading.table = false
                if(response) {            
                  this.data = response.data.data
                }
                
            } catch (error) {
                this.loading.table = false
                console.log(error);
            }
        },

        async handleSwitchChange(val, item){
          const sts = val ? '1' : '0';
          const dat = this.data.find((d) => d.id_pelayanan_kesehatan === item.id_pelayanan_kesehatan)
          if (dat) {
            dat.aktif_sts = sts
          }
          const params = {
            id: item.id_pelayanan_kesehatan,
            status: sts
          }

          try {
            const response = await this.asyncAxiosPut("pelayanan/status_update", "json", this.getAuth, params)
            this.displayMessageValue("success-basic", response.message);
          } catch (error) {
            console.log(error);
          }
        },

        showModalCreate(){
          this.state.modalMode = 'create'
          this.visibleModalCreate = true
          this.modalTitle = 'Create Pelayanan Kesehatan'
          if(this.combo.length == 0){
            this.fetchCombo()
          }
        },

        showModalCreateEdit(value){
          this.state.modalMode = 'edit'
          this.visibleModalCreate = true
          this.modalTitle = 'Edit Pelayanan Kesehatan'
          this.state.editData = value

          if(this.combo.length == 0){
            this.fetchCombo()
          }

          this.$nextTick(() => {
            this.form.setFieldsValue({
              kode_layanan: value.kode_layanan,
              plafon_layanan: value.plafon_group,
              group_layanan: value.group_pelayanan,
              nama_layanan: value.nama_pelayanan,
              note: value.note,
              plan_layanan: value.plan,
              persentase_klaim: value.persentase_klaim
            })
          });
        },

        closeModalCreate(){
          this.visibleModalCreate = false
          this.form.resetFields()
        },

        async fetchCombo(){
          try {
            const response = await this.asyncAxiosGet("pelayanan/create_combo", this.getAuth, {})
            this.combo = response.data.combo
            this.plan = response.data.plan
          } catch (error) {
            console.log(error);
          }
        },

        handleGroupChange(value){
          const item = this.combo.find((d) => d.option === value)
          this.plafonVisible = item.keterangan_plafon == 0 ? false : true
           
          this.form.setFieldsValue({
            kode_layanan: item.keterangan_kode,
            plafon_layanan: item.keterangan_plafon
          })
        },

        handleSubmit(){
          this.loading.btn_submit = true
          this.form.validateFields( async (err, values) => {
            if (err) {
              this.loading.btn_submit = false
              this.displayMessage("form-warning");
              return;
            }

            try {
              const payload = {
                kode : values.kode_layanan,
                group: values.group_layanan,
                nama: values.nama_layanan,
                keterangan: values.note,
                plafon : values.plafon_layanan,
                plan : values.plan_layanan,
                persentase : values.persentase_klaim
              }

              const response = await this.asyncAxiosPost("pelayanan/store", "json", this.getAuth, payload)

              if(response){
                this.fetchList()

                this.closeModalCreate()
                this.displayMessage("success-save");
              }
              this.loading.btn_submit = false
            } catch (error) {
              this.loading.btn_submit = false
              this.displayMessageValue("error-basic", "Internal server error");
            }
          })
        },

        handleUpdateSubmit(){
          this.loading.btn_submit = true
          this.form.validateFields( async (err, values) => {
            if (err) {
              this.loading.btn_submit = false
              this.displayMessage("form-warning");
              return;
            }

            try {
              const payload = {
                id: this.state.editData.id_pelayanan_kesehatan,
                kode : values.kode_layanan,
                group: values.group_layanan,
                nama: values.nama_layanan,
                keterangan: values.note,
                plafon : values.plafon_layanan,
                plan : values.plan_layanan,
                persentase : values.persentase_klaim
              }

              const response = await this.asyncAxiosPut("pelayanan/update", "json", this.getAuth, payload)

              if(response){
                this.fetchList()

                this.closeModalCreate()
                this.displayMessage("success-save");
              }
              this.loading.btn_submit = false
            } catch (error) {
                this.loading.btn_submit = false
                this.displayMessageValue("error-basic", "Internal server error");
            }
          })
        }
    }
}

</script>

<style>
  .action-sect {
    display: flex;
    flex-direction: row;
    gap: 10px;
    justify-content: center;
    align-items: center;
  }
</style>